import Permission from "../../../../../common/components/auth/Permission";
import { IMaintenance } from "../../../../../types/maintenance.type";
import { useMaintenanceDashboardContext } from "./Maintenance.context";
import "./index.scss";
import { checkConfirmkMaintenance } from "../../../../../common/services/maintenance.api";
import {
  cleanMaskCurrency,
  newMaskCurrency,
} from "../../../../../common/helpers/mask.helpers";
import { InfoTableColumn } from "../../../../../common/components/ui/table/InfoTableColumn";
import { useToastContext } from "../../../../../common/components/ui/toast/toast.context";
import { useEffect, useState } from "react";
import { formatDateAndTime } from "../../../../../common/helpers/date.helpers";
import { useNavigate } from "react-router-dom";
import { upsertPartnerCharge } from "@/common/services/partner-charge.api";

export function MaintenanceReportsDashboard() {
  const { maintenances } = useMaintenanceDashboardContext();
  const [maintenanceState, setMaintenanceState] =
    useState<IMaintenance[]>(maintenances);
  const { notifySuccess, notifyError, notifyInfo } = useToastContext();
  const navigate = useNavigate();

  useEffect(() => {
    setMaintenanceState(maintenances);
  }, [maintenances]);

  const handleConfirm = async (maintenance: IMaintenance, itens) => {
    if (!maintenance._id) {
      notifyError("Not found _id");
      return;
    }
    if (maintenance.chargeMaintenance?.charged) {
      notifyInfo("Já foi Cobrado essa Manutenção, impossibilitando alteração");
      return;
    }
    const data = {
      licensePlate: maintenance.licensePlate,
      itens: itens,
    };

    const confirmData = await checkConfirmkMaintenance(maintenance._id, data);
    if (!confirmData.ok) {
      notifyError(confirmData.message as string);
      return;
    }

    const maintenanceUpdatedIndex = maintenances.findIndex(
      (m) => m._id === confirmData.data._id,
    );

    const updatedMaintenances = [...maintenances];
    updatedMaintenances[maintenanceUpdatedIndex].chargeMaintenance = {
      charged: maintenance.chargeMaintenance?.charged || false,
      confirmed: true,
      wasInsertedMaintenanceCharges:
        maintenance.chargeMaintenance?.wasInsertedMaintenanceCharges || false,
    };

    setMaintenanceState(updatedMaintenances);

    const allMaintenancesConfirmed = updatedMaintenances.every(
      (m) => m.chargeMaintenance?.confirmed,
    );

    const maintenancesToCharge = updatedMaintenances.filter(
      (m) =>
        m.chargeMaintenance?.confirmed &&
        !m.chargeMaintenance.wasInsertedMaintenanceCharges,
    );

    if (maintenancesToCharge.length && allMaintenancesConfirmed) {
      const references = maintenancesToCharge.map((m) => ({
        type: "manutenção",
        id: m._id as string,
      }));

      // Enviando a placa ao invés do partnerId
      await upsertPartnerCharge({
        referenceId: references,
        licensePlate: maintenances[0].licensePlate,
        partnerCompanyName: maintenances[0].partnerCompanyName,
        companyId: maintenances[0].companyId,
        notes: "",
      });

      navigate("/relatorios/manutencao/");
    }
    notifySuccess("Sucesso ao Confirmar Manutenção");
  };

  return (
    <div className="containerMaintenanceReports">
      <Permission permission="edit:inventory-pieces">
        {maintenanceState.length > 0 &&
          [...maintenanceState]
            .sort(
              (a, b) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime(),
            )
            .map((maintenance) => {
              const { corrective, misuse, preventive } =
                maintenance.budgetMaintenance;
              const itens = corrective.concat(misuse).concat(preventive);
              const piecesHTML = itens.map((item, index) => {
                let types = ["Corretiva", "Preventiva", "misuse"]
                  .filter((type) => type !== item.type)
                  .filter((type) => type !== "misuse");

                let type = item.type;
                if (item.type === "misuse") {
                  type = "Mau Uso";
                } else {
                  types.push("Mau uso");
                }

                types.push(type);
                types = types.reverse();

                return (
                  <InfoTableColumn
                    data={[
                      {
                        label: index > 0 ? "" : "Data",
                        value: formatDateAndTime(maintenance.createdAt),
                      },
                      {
                        label: index > 0 ? "" : "Código da Peça",
                        value: item.code,
                      },
                      { label: index > 0 ? "" : "Descrição", value: item.name },
                      {
                        label: index > 0 ? "" : "Quantidade",
                        value: item.quantity,
                      },
                      {
                        label: index > 0 ? "" : "Preço",
                        value: newMaskCurrency(item.sellPrice),
                        editable: true,
                        inputChange: (value) => {
                          item.sellPrice = cleanMaskCurrency(value);
                          itens[index] = item;
                        },
                      },
                      {
                        label: index > 0 ? "" : "Tipo",
                        value: item.type,
                        selectOption: types,
                        clickSelect: (type) => {
                          item.type = type;
                          itens[index] = item;
                        },
                      },
                    ]}
                  ></InfoTableColumn>
                );
              });

              return (
                <div className="w-full md:w-4/5  mx-auto">
                  <section className="bg-gray/20 p-6 dark:text-black rounded-xl mb-6 shadow-md border border-gray-200">
                    <div className="mb-6 space-y-2">
                      <h2 className="text-lg font-semibold text-gray-700">
                        Peças usadas na Manutenção:{" "}
                        <span
                          className={
                            maintenance.chargeMaintenance?.confirmed
                              ? "text-green-600"
                              : "text-yellow-600"
                          }
                        >
                          {maintenance.chargeMaintenance?.confirmed
                            ? "Confirmado"
                            : "Pendente"}
                        </span>
                      </h2>

                      <p className="text-md text-muted-foreground">
                        <span className="font-medium text-gray-800">
                          Cliente:
                        </span>{" "}
                        {maintenance.name} ({maintenance.typePlanRenter})
                      </p>
                      <p className="text-md text-muted-foreground">
                        <span className="font-medium text-gray-800">
                          Hodômetro:
                        </span>{" "}
                        {maintenance.odometer}
                      </p>
                    </div>

                    {piecesHTML}

                    {maintenance.observations.map((obs, index) => (
                      <div className="mt-3">
                        <p className="font-medium">Observações:</p>
                        <div>
                          <li className="list-none" key={index}>
                            <p>{obs.author}</p>
                            <p>{obs.text}</p>
                          </li>
                        </div>
                      </div>
                    ))}

                    <div className="mt-6 flex justify-end">
                      <button
                        className="btn btn-success"
                        onClick={() => handleConfirm(maintenance, itens)}
                      >
                        Confirmar
                      </button>
                    </div>
                  </section>
                </div>
              );
            })}
      </Permission>
    </div>
  );
}
